import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SearchFieldComponent } from '../search-field/search-field.component';
@Component({
  selector: 'lib-editdelete',
  standalone: true,
  imports: [CommonModule, MatIconModule, SearchFieldComponent],
  template: `<section class="flex items-center justify-center gap-7">
    <!-- edit and delete -->
    <!-- <div class="flex items-center justify-center gap-4">
    <div class="flex items-center justify-center gap-2 cursor-pointer">
      <mat-icon class="text-mdPrimary-500">edit</mat-icon>
      <p class="text-base font-bold">Edit</p>
    </div>
    <div class="flex items-center justify-center gap-2 cursor-pointer">
      <mat-icon class="text-e-error">delete</mat-icon>
      <p class="text-base font-bold">Delete</p>
    </div>
  </div> -->

    <ng-container *ngIf="seachEnable">
      <lib-search-field (applySearch)="applySearch($event)"></lib-search-field>
    </ng-container>

    <!-- <ng-container *ngIf="filterBtnEnable">
      <lib-button
        [btnType]="'transparent'"
        [imgURL]="'/public/images/filtericon.svg'"
        [label]="'Filter'"
      ></lib-button>
    </ng-container> -->
  </section>`,
  styles: [],
})
export class EditdeleteComponent {
  @Input() seachEnable: boolean = false;
  @Input() filterBtnEnable: boolean = false;
  @Output() applySearchOption = new EventEmitter<Event>();
  applySearch(event: any) {
    this.applySearchOption.emit(event);
  }
}
